import React, { useEffect, useRef, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { AnswerItem, QuestionValidationTypes, ReduxState, QuestionItems, FormShowType } from 'interface';
import { QuestionSLPRef, SLPQuestionType } from '../../questions.index';
import SLPOptions, { OptionItemType, SLPOptionRef } from 'utilities/slp/options/options.index';
import { extractTitle } from 'scripts/string';
import { createQuestionTitle } from '../questionsTypes.script';

const SLPOptionsQuestion: React.ForwardRefRenderFunction<
    QuestionSLPRef,
    ConnectedProps<typeof connector> & SLPQuestionType
> = (props: ConnectedProps<typeof connector> & SLPQuestionType, ref) => {
    React.useImperativeHandle(ref, () => ({
        validate: (e?: boolean) => validate(e),
        submit: (e?: boolean) => onSubmit(e),
    }));
    const lang = props.lang.SLP.questionsTypes;
    const question = props.question;
    const inputRef = useRef<SLPOptionRef>(null);
    // const [multi, setMulti] = useState(false);
    const multi = !!question.validations?.find((i) => i.title === QuestionValidationTypes.selective)?.value;
    const items: OptionItemType[] = [];
    question.items
        ?.sort((a, b) => (a.order ? a.order : a.id) - (b.order ? b.order : b.id))
        .map((i) =>
            items.push({ title: i.title, payload: i.id, value: i.value, archive: i.archive, isHidden: i.is_hidden }),
        );
    const [title, setTitle] = useState(question.title);
    const index = props.answerList?.findIndex((i) => i.question.id === question.id);
    const [text, setText] = useState<string>();

    const [hint, setHint] = useState(question.description);

    useEffect(() => {
        if (question.description)
            setHint(
                createQuestionTitle(
                    question.description,
                    props.answerList,
                    props.answer?.answerer_info,
                    props.form.indicators,
                ),
            );
        setTitle(
            createQuestionTitle(question.title, props.answerList, props.answer?.answerer_info, props.form.indicators),
        );
    }, [props.answerList]);

    // useEffect(
    //     () => setMulti(!!question.validations?.find((i) => i.title === QuestionValidationTypes.selective)?.value),
    //     [],
    // );

    function validate(e?: boolean) {
        const value = inputRef.current?.getValue();
        if (question.is_required && value && value?.length < 1) {
            if (e) inputRef.current?.setError(multi ? lang.multiSelectEmp : lang.selectiveErr);
            return false;
        }
        return true;
    }

    function setAnswer() {
        const value = inputRef.current?.getValue();
        const isMore = value?.findIndex((item) => Number(item.value) === 1);
        const data = [...props.answerList];
        if (validate() && value?.length) {
            const response: AnswerItem = {
                question_items: value?.map((i) => ({
                    title: i.title,
                    id: i.payload,
                    payload: i.payload,
                    value: isMore !== undefined && isMore > -1 ? '1' : undefined,
                })),
                question: props.question,
                id: new Date().getTime(),
                answer: props.answer?.id,
            };
            if (isMore !== undefined && isMore > -1) response.value = text;
            if (index !== undefined && index > -1) {
                data[index] = response;
            } else {
                data?.push(response);
            }
        } else if (index !== undefined && index > -1) data.splice(index, 1);
        props.setAnswerList(data);
    }

    function onSubmit(e?: boolean) {
        const value = inputRef.current?.getValue();
        const isMore = value?.findIndex((item) => Number(item.value) === 1);
        if (
            (value?.length || props.answerList?.find((i) => i.id === question.id)?.question_items?.length) &&
            validate(e) &&
            props.answer
        ) {
            props.submit({
                answer: props.answer.id,
                question_items: value?.map((i) => ({
                    title: i.title,
                    id: i.payload,
                    payload: i.payload,
                    value: isMore !== undefined && isMore > -1 ? '1' : undefined,
                })),
                question: question,
                id: new Date().getTime(),
                value: isMore !== undefined && isMore > -1 ? text : '',
            });
        }
    }

    return (
        <SLPOptions
            hasBorder
            hint={extractTitle(hint, false, false)}
            ref={inputRef}
            counter={props.counter}
            label={extractTitle(title, false, false)}
            image={question.image_file}
            items={items}
            vertical={
                Number(question.validations?.find((i) => i.title === QuestionValidationTypes.orientation)?.value) !== 1
            }
            multiSelect={multi}
            color={props.form?.answer_color}
            labelColor={props.form?.question_color}
            required={question.is_required}
            onChange={setAnswer}
            onTextChange={(e) => setText(e)}
            dir={props.form.direction}
            next={props.form.show_type === FormShowType.single ? props.next : undefined}
            defaultValue={
                index !== undefined && index > -1 && props.answerList[index].question_items
                    ? props.answerList[index].question_items?.map((i) => ({ title: i.title, payload: i.id }))
                    : undefined
            }
        />
    );
};
const mapStateToProps = (state: ReduxState) => ({
    direction: state.direction,
    lang: state.lang,
});

const connector = connect(mapStateToProps, null, null, { forwardRef: true });
export default connector(React.forwardRef(SLPOptionsQuestion));
